<template>
  <section>
    <div class="row outcomes-row">
      <div v-if="outcome" class="col-md-12 outcome-title">
        <div class="outcome-title-text">
          <div
            class="outcome-title-header"
            v-html="cms.asHtml(outcome.full_title)"
            data-test="pathway-outcome-title"
          ></div>
          <p
            class="outcome-title-desc"
            v-html="cms.asHtml(outcome.brief_description)"
            data-test="pathway-outcome-desc"
          ></p>
        </div>
        <div class="outcome-image-container">
          <img
            :src="outcome.image.url"
            :alt="cms.asText(outcome.name)"
            class="outcome-image"
            data-test="pathway-outcome-img"
          />
        </div>
      </div>
      <router-view
        @displayNextButton="displayNextButton"
        @hide-stepper="hideStepper"
        :isTeamLeaderOrOrgAdmin="isTeamLeaderOrOrgAdmin"
        :teamId="teamId"
        :orgId="orgId"
        ref="view"
      />
      <div class="col-md-12 text-center next-button-container">
        <router-link
          v-if="isNextButtonDisplayed && pathwayUid.length > 0"
          :to="`pathway/${pathwayUid}${route.query.asaccredited ? `?asaccredited=${route.query.asaccredited}` : ''}`"
        >
          <button v-if="isNextButtonDisplayed" class="btn btn-primary" data-test="pathway-next">
            Next
          </button>
        </router-link>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { debug as d } from "debug";
import { onBeforeMount, provide, ref, computed } from "vue";
import { useRoute } from "vue-router";
import {
  CmsDocumentTypes,
  CmsGoalData,
  CmsPathwaysRelationship,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { csContext } from "../../services/cs-context";

const debug = d;

const props = defineProps<{ isTeamLeaderOrOrgAdmin: boolean }>();

const route = useRoute();
const origin = computed(() => route.query.origin as string);

const pathwayUid = ref("");
const outcomeUid = ref("");
const outcome = ref<CmsGoalData | null>(null);
const teamId = ref("");
const isNextButtonDisplayed = ref(false);
const orgId = ref(csContext.user?.organisation?.id ?? "");

function displayNextButton(uid: string): void {
  pathwayUid.value = uid;
  isNextButtonDisplayed.value = props.isTeamLeaderOrOrgAdmin || route.query.asaccredited === 'true';
}

const emit = defineEmits(["hide-stepper", "update-stepper"]);

function hideStepper(): void {
  emit("hide-stepper");
}

const pathways = ref<CmsPathwaysRelationship[]>([]);
provide("teamPathways", pathways);

onBeforeMount(async () => {
  debug("response");
  outcomeUid.value = route.params.outcomeUid as string;
  const response = await cms.getByUid(CmsDocumentTypes.CmsTeamGoal, outcomeUid.value);
  console.log('CMS Response:', response);
  outcome.value = response.data;
  console.log('Outcome data:', outcome.value);
  pathways.value = outcome.value.pathways;
  console.log('Pathways:', pathways.value);
  emit("update-stepper", route.name);
  
  // Ensure we have valid teamId and orgId
  if (!route.params.id) {
    console.error('Team ID is missing from route params');
    return;
  }
  teamId.value = route.params.id as string;
  
  if (!csContext.user?.organisation?.id) {
    console.error('Organization ID is missing from user context');
    return;
  }
  orgId.value = csContext.user.organisation.id;
});
</script>

<style scoped lang="less">
@import "../../styles/outcomes/pathways";
</style>

<style lang="less">
@import "../../styles/outcomes/pathways-prismic-content";
</style>
